import { __decorate, __metadata, __param } from "tslib";
import { Inject, Injectable } from 'angular-ts-decorators';
var PfmLoadQueueService = (function () {
    function PfmLoadQueueService($log) {
        this.$log = $log;
        this.queue = [];
    }
    PfmLoadQueueService.prototype.add = function (name) {
        if (!name) {
            this.$log.warn('Provided queue item name is not a string or empty.');
            return;
        }
        if (this.queue.indexOf(name) > -1) {
            this.$log.warn('Provided queue item name is already present in queue. ', name);
            return;
        }
        this.$log.info('Adding queue item. ', name);
        this.queue.push(name);
    };
    PfmLoadQueueService.prototype.isEmpty = function () {
        return this.queue.length === 0;
    };
    PfmLoadQueueService.prototype.remove = function (name) {
        var queueItemIndex;
        if (!name) {
            this.$log.warn('Provided queue item name is not a string or empty.');
            return;
        }
        queueItemIndex = this.queue.indexOf(name);
        if (queueItemIndex === -1) {
            this.$log.warn('Provided queue item name is not present in queue. ', name);
            return;
        }
        this.$log.info('Removing queue item. ', name);
        this.queue.splice(queueItemIndex, 1);
    };
    PfmLoadQueueService.$inject = ['$log'];
    PfmLoadQueueService = __decorate([
        Injectable('pfmLoadQueue'),
        __param(0, Inject('$log')),
        __metadata("design:paramtypes", [Object])
    ], PfmLoadQueueService);
    return PfmLoadQueueService;
}());
export { PfmLoadQueueService };
